// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import React, { useState } from 'react';
import { dialogContext } from './dialog-context';
import { StarUsDialog } from '@/dialogs/star-us-dialog/star-us-dialog';

export const DialogProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [openStarUsDialog, setOpenStarUsDialog] = useState(false);

  return (
    <dialogContext.Provider
      value={{
        openStarUsDialog: () => setOpenStarUsDialog(true),
        closeStarUsDialog: () => setOpenStarUsDialog(false),
      }}
    >
      {children}

      <StarUsDialog dialog={{ open: openStarUsDialog }} />
    </dialogContext.Provider>
  );
};
